export default __webpack_public_path__ + "static/media/bg-login.7d7be7ca.png";